"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;
// import galleryItems from '../../data/galleryItems/galleryItems';

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _GalleryModal = require("./GalleryModal");

var _GalleryModal2 = _interopRequireDefault(_GalleryModal);

var _redial = require("redial");

var _reactRedux = require("react-redux");

var _gallery = require("redux/modules/gallery");

var _components = require("components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cloudfrontThumbs = function cloudfrontThumbs(path) {
  return "https://cdn.quixel.com/quixel/thumbs/" + path;
};

var GalleryPopupContainer = (_dec = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var dispatch = _ref.store.dispatch;

    return dispatch((0, _gallery.getGalleryData)());
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    galleryData: state.gallery.data,
    loading: state.gallery.loading,
    loaded: state.gallery.loaded,
    loggedIn: state.auth.loggedIn
  };
}), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(GalleryPopupContainer, _React$Component);

  function GalleryPopupContainer() {
    (0, _classCallCheck3.default)(this, GalleryPopupContainer);
    return (0, _possibleConstructorReturn3.default)(this, (GalleryPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(GalleryPopupContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(GalleryPopupContainer, [{
    key: "render",
    value: function render() {
      // const isPopup = this.props.location.state.modal;
      var isPopup = void 0;
      if (this.props.isPopup) {
        isPopup = this.props.isPopup;
      }

      var galleryItems = this.props.galleryData;

      var itemIndex = this.props.params.index;

      // const selectedItem = R.find(R.propEq('index', parseInt(itemIndex, 10)))(galleryItems);

      var selectedItem = galleryItems[+itemIndex];
      if (!selectedItem) return _react2.default.createElement("div", null);

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "| Community Art Gallery | " + (selectedItem.title ? selectedItem.title : "Unnamed Artwork") + " | " + selectedItem.author,
          documentImage: cloudfrontThumbs("page-thumb-gallery.jpg"),
          documentDescription: (selectedItem.author && selectedItem.author.trim()) + " shares project " + (selectedItem.title ? selectedItem.title : "Unnamed Artwork") + ". Find out more at " + selectedItem.link + ". Catch a glimpse of all the amazing worlds our community is building."
        },
        _react2.default.createElement(_GalleryModal2.default, {
          image: selectedItem.src,
          author: {
            name: selectedItem.author,
            title: selectedItem.title ? selectedItem.title : "Unnamed Artwork",
            description: selectedItem.description,
            url: selectedItem.link,
            links: []
          },
          info: this.props.info,
          imageData: selectedItem,
          tools: selectedItem.tools,
          onRequestForBeingFeatured: this.props.loggedIn ? {
            pathname: "/submitartwork",
            state: {
              modal: true
            }
          } : {
            pathname: "/login",
            search: "?returnTo=/submitartwork",
            state: {
              modal: true
            }
          },
          isPopup: isPopup
        })
      );
    }
  }]);
  return GalleryPopupContainer;
}(_react2.default.Component)) || _class) || _class);
exports.default = GalleryPopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPopup/GalleryPopup.jsx
// module id = 2781
// module chunks = 0